import React from "react";
import { Tab } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getName, getPartnerId, partnerDob } from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import deleteIcon from "../../../asset/images/deleteicon.svg"


function PartnerOnboardingActive(props) {
    let partnerOnboardingData = props.partnerOnboardingData
    let getDispositionMaster = props.getDispositionMaster
    let partnerSource = props.partnerSource
    let linecard = props.linecard;
    let navigate = useNavigate();
    let serverError = props.serverError;
  
    return (
        <>
            <Tab.Pane eventKey="active" className="createdClass">
                <div className="row">
                    <div className="col-12">
                        <div
                            className="oboarding-block-wrapper card-box alert-table text-center partner-wrapper"
                            onScroll={(e) => props.handleScroll(e)}
                        >
                            {partnerOnboardingData.length > 0 ? (
                                <div
                                    className={` ${linecard === "block-active col-division-5"
                                        ? "onboarding-card-wrapper"
                                        : ""
                                        }`}
                                >
                                    {partnerOnboardingData.map((item) => {
                                        return (
                                            <div className={`w-100 bottom-25 ${linecard}`}>
                                                <div className="card-box onboarding-card">
                                                    <div className="client-img-checkbox-wrapper">
                                                        <div className="client-img-wrapper">
                                                            <div className="profile-image">
                                                                {getName(item?.nameOnPan?.toUpperCase())}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="onboarding-card-content">
                                                        <div className="onboarding-card-top">
                                                            <div className="user-email-wrapper">
                                                                <p className="username">
                                                                    <span onClick={() => {
                                                                        getPartnerId(item?.id)
                                                                        navigate("/partner-application");
                                                                    }}>{item?.nameOnPan?.toUpperCase()}</span>
                                                                </p>
                                                                <p className="email">{item?.email}</p>
                                                            </div>
                                                        </div>

                                                        <div className="clientname-info ">
                                                            <div className="client-data-partner">
                                                                <ul className="call-web-wrapper justify-content-center">
                                                                    <li className="created-time-wrapper">
                                                                        <span className="icon-calendar onboard-pending-icon"></span>
                                                                        <span className="onboard-sm-icon-label">
                                                                            <span>
                                                                                {partnerDob(item?.CreatedAt)}
                                                                            </span>
                                                                        </span>
                                                                    </li>
                                                                </ul>

                                                                <div className="client-info-status">
                                                                    <ul className="status-wrap-check">
                                                                        <li className="created-time-wrapper">
                                                                            {linecard === "block-active col-division-5" ?
                                                                                (
                                                                                    <div className="status-ui">
                                                                                        <ul>
                                                                                            <li className="status-text partner-status">
                                                                                                <span className="onboard-sm-icon-label">
                                                                                                    <td>
                                                                                                        {item?.statusId === 3 && (
                                                                                                            <button
                                                                                                                className="status-btn"

                                                                                                            >
                                                                                                                ACTIVE
                                                                                                            </button>
                                                                                                        )}
                                                                                                    </td>
                                                                                                </span>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div>
                                                                                ) :
                                                                            ""}
                                                                        </li>
                                                                    </ul>
                                                                </div>

                                                                <div className="client-info-status">
                                                                    <ul className="call-web-wrapper">
                                                                        <li className="created-time-wrapper">
                                                                            <span className="icon-client-code onboard-pending-icon"></span>
                                                                            <span className="onboard-sm-icon-label">
                                                                                <span>{item?.pan}</span>
                                                                            </span>
                                                                        </li>
                                                                        <li>
                                                                            <span className="icon-phone-icon onboard-pending-icon"></span>
                                                                            <span className="onboard-sm-icon-label">
                                                                                <span>{item?.mobile}</span>
                                                                            </span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="client-info-status">
                                                                <ul className="call-web-wrapper disposition-wrapper">
                                                                    <li>
                                                                        <div className="disposition-select">
                                                                            <label htmlFor="" className="form-text">Disposition</label>
                                                                            <select name="" onChange={(e) => props.handleInputChange(e, item.id)}>
                                                                                {getDispositionMaster &&
                                                                                    getDispositionMaster?.map((item) => {
                                                                                        return (
                                                                                            <>
                                                                                                <option value={item.id}>{item.reason}</option>
                                                                                            </>
                                                                                        );

                                                                                    })}
                                                                            </select>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className="disposition-select">
                                                                            <label htmlFor="" className="form-text">Partner Source</label>
                                                                            <select name="" id="" onChange={(e) => props.handlePartnerInput(e, item.id)}>
                                                                                {partnerSource &&
                                                                                    partnerSource?.map((item) => {
                                                                                        return (
                                                                                            <>
                                                                                                <option value={item.id}>{item.category}</option>
                                                                                            </>
                                                                                        );

                                                                                    })}
                                                                            </select>
                                                                        </div>
                                                                    </li>
                                                                    {/* <li>
                                                                        <span
                                                                        >
                                                                            <img src={deleteIcon} alt="" onClick={() => props.deleteApi(item.id)} className="par-delete-icon" />
                                                                        </span>
                                                                    </li> */}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : serverError ===
                                "Something went wrong, Please try again later." ? (
                                <h4 className="alert-title mb-0">{serverError}</h4>
                            ) : (
                                <div className="alert-title mb-0">
                                    <h3>{Constants.No_Data}</h3>
                                </div>
                            )}
                            {props.scrollLoader && (
                                <div className="loader-center">
                                    <Loader />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Tab.Pane>
        </>
    );
}

export default PartnerOnboardingActive;
